import CountCell from 'components/CountCell';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedFleet } from '../..';

interface DepotsCellProps {
  rowData: ManagedFleet;
}

export default function DepotsCell({
  rowData: { id, totals, sentinelTeam },
}: DepotsCellProps) {
  return (
    <CountCell
      count={totals?.enabledAssetGroupingsCount}
      sectionPath={ROUTE_NAMES.admin.managementDepots}
      pageParams={{
        accountIds: [id],
        teamIds: [sentinelTeam.id],
        oemSegmentIds: sentinelTeam.oemSegment?.id
          ? [sentinelTeam.oemSegment?.id]
          : [],
        depotIds: [],
      }}
    />
  );
}
